import { LayoutRegistered } from "layouts/LayoutHelper";
import DefaultLayout from "layouts/default/DefaultLayout";
import FrontendTheme from "themes";

export default {
  [LayoutRegistered.defaultLayout]: {
    component: DefaultLayout,
    isDefault: true,
  },
  [LayoutRegistered.frontend]: {
    component: FrontendTheme,
  },
};
